import React from 'react';
export const AdDisclosure = () => {
  return <div className="bg-gray-100 text-gray-700 text-xs py-1 text-center" data-id="element-17">
      <p data-id="element-18">Annonslänk: Detta inlägg innehåller affiliatelänkar</p>
    </div>;
};